const A="X-Api-Auth-Token",E="X-Api-Request-ID",_="language",n="domain";export{A as HEADER_X_API_AUTH_TOKEN,E as HEADER_X_API_REQUEST_ID,_ as HEADER_LANGUAGE,n as HEADER_DOMAIN};
